export const SortIcon = ({ status = undefined }) => {
  return (
    <svg
      width="8"
      height="10"
      viewBox="0 0 8 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_786_33333)">
        <path
          d="M3.574 6.07029C4.63488 6.07028 5.69578 6.07069 6.75668 6.06982C6.91113 6.0697 7.02989 6.1287 7.10292 6.26649C7.17538 6.40319 7.15174 6.56358 7.04218 6.67341C6.55805 7.15873 6.07257 7.64271 5.58808 8.1277C5.00535 8.71105 4.42325 9.29503 3.84057 9.87844C3.75818 9.96093 3.66084 10.01 3.54087 9.99832C3.4324 9.98778 3.35248 9.92831 3.27714 9.85239C2.85248 9.42447 2.42501 8.99934 1.99854 8.57321C1.62434 8.19931 1.25035 7.8252 0.876029 7.45143C0.620842 7.19663 0.365075 6.94243 0.109875 6.68765C0.00478406 6.58273 -0.0266903 6.42479 0.029323 6.28953C0.0864585 6.15155 0.213819 6.07054 0.378719 6.07048C1.4438 6.07014 2.5089 6.0703 3.574 6.07029Z"
          fill={!status || status === "descend" ? "black" : "#393DB8"}
        />
        <path
          d="M3.57199 3.93193C2.50903 3.93193 1.44606 3.93207 0.383094 3.93179C0.202961 3.93174 0.0700654 3.84007 0.0180116 3.67534C-0.0262997 3.53512 0.0132199 3.41035 0.113784 3.30952C0.788718 2.63289 1.46538 1.95801 2.14176 1.28284C2.53502 0.89029 2.92918 0.498651 3.32209 0.105776C3.46203 -0.0341567 3.67949 -0.0352033 3.81804 0.102358C4.1824 0.46415 4.54591 0.826811 4.90925 1.18962C5.17127 1.45127 5.43237 1.71382 5.69411 1.97575C6.05102 2.33293 6.40824 2.68979 6.76509 3.04702C6.85764 3.13965 6.95062 3.23189 7.04105 3.32657C7.14941 3.44002 7.17467 3.57346 7.1117 3.71586C7.05062 3.85399 6.93656 3.92779 6.78607 3.93063C6.55298 3.93503 6.31973 3.93192 6.08655 3.93193C5.24837 3.93194 4.41019 3.93193 3.57199 3.93193Z"
          fill={!status  || status === "ascend" ? "black" : "#393DB8"}
        />
      </g>
      <defs>
        <clipPath id="clip0_786_33333">
          <rect width="7.14567" height="10" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
